import axiosInstance from 'libs/axios'
import { useEffect, useReducer } from 'react'
import { useNavigate } from 'react-router-dom'
import { METHOD } from './method'
import { Alert } from 'avo-ui'
import { useDispatch } from 'react-redux'
import { setErrorData, setProfile } from 'reducers/homeReducer'

const initialData = {
    isLoading: false,
    data: null,
    error: null,
}

const ACTION_TYPE_RESPONSE = {
    SUCCESS: 'SUCCESS',
    LOADING: 'LOADING',
    ERROR: 'ERROR',
}

const responseReducer = (state, action) => {
    switch (action.type) {
        case ACTION_TYPE_RESPONSE.SUCCESS:
            return {
                isLoading: false,
                data: action.payload,
                error: null,
            }
        case ACTION_TYPE_RESPONSE.LOADING:
            return {
                ...state,
                isLoading: true,
            }
        case ACTION_TYPE_RESPONSE.ERROR:
            return {
                isLoading: false,
                data: null,
                error: action.payload,
            }
        default:
            return state
    }
}
const defaultOptions = {
    isFetching: false,
    isLoading: false,
}

export const useFetch = ({ api, method, initPathVariable }, initPayload, options = defaultOptions) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [data, dispatchResponse] = useReducer(responseReducer, { ...initialData, isLoading: options.isLoading })
    let attempt = 0

    useEffect(() => {
        if (options.isFetching) fetching()
    }, [])

    const fetching = async (payload, pathVariable, header, responseType, additionalQueryParams = {}) => {
        dispatchResponse({ type: ACTION_TYPE_RESPONSE.LOADING })

        const clearAllReducer = () => {
            dispatch(setProfile(null))
            localStorage.clear()
        }

        const errorMessage = (response) => {
            if (response?.code === 'ERR_NETWORK') {
                return 'Something Wrong, Please Check Your Connection'
            } else {
                return response?.data?.message || 'Terjadi Kesalahan'
            }
        }

        const handlingError = (response) => {
            dispatchResponse({ type: ACTION_TYPE_RESPONSE.ERROR, payload: response?.data })
            Alert({
                icon: 'error',
                title: 'Oops!',
                message: errorMessage(response),
            })
            throw response?.data || response
        }

        const request = async () => {
            const requestKey = method === METHOD.GET ? 'params' : 'data'
            try {
                const XMASCTOK = localStorage.getItem('identifier') || null

                const response = await axiosInstance({
                    url: `${api}${initPathVariable || pathVariable ? '/' + (initPathVariable || pathVariable) : ''}`,
                    method: method,
                    [requestKey]: { ...initPayload, ...payload },
                    [Object.keys(additionalQueryParams).length > 0 ? 'params' : null]: {
                        ...additionalQueryParams,
                    },
                    headers: {
                        ...header,
                        ...(method !== METHOD.GET && XMASCTOK && { 'x-mas-ctok': XMASCTOK }),
                    },
                    responseType,
                })
                dispatchResponse({ type: ACTION_TYPE_RESPONSE.SUCCESS, payload: response.data.data })
                return response.data
            } catch (error) {
                if (attempt === 2) {
                    handlingError(error?.response)
                    throw error?.response?.data
                }
                switch (error?.response?.status) {
                    case 401:
                        switch (error?.response?.data?.code) {
                            case '401-A010':
                            case '401-A011':
                            case '401-A012':
                                Alert({
                                    icon: 'error',
                                    title: 'Authentication Error !',
                                    message: error.response.data.message,
                                    buttonConfirmText: 'OK',
                                    autoClose: false,
                                }).then(() => {
                                    clearAllReducer()
                                    navigate('/', { replace: true })
                                })
                                break
                            default:
                                handlingError(error?.response)
                        }
                        break
                    case 403:
                        if (error?.response?.data?.code === '403-A001') {
                            clearAllReducer()
                            navigate('/', { replace: true })
                            handlingError(error?.response)
                            throw error?.response?.data
                        }
                        const newResponse = {
                            ...error?.response,
                            data: { ...error?.response?.data, message: 'Anda tidak memiliki akses' },
                        }
                        handlingError(newResponse)
                        break
                    case 503:
                        if (error?.response?.data?.code === '503-B000') {
                            clearAllReducer()
                            dispatch(setErrorData(error?.response?.data?.data))
                            navigate('/under-maintenance', { replace: true })
                            dispatchResponse({ type: ACTION_TYPE_RESPONSE.ERROR, payload: error?.response?.data })
                            handlingError(error?.response)
                            throw error?.response?.data
                        }
                        handlingError(error?.response)
                        break
                    default:
                        handlingError(error?.response || error)
                }
            }
        }
        return await request()
    }

    return { data, fetching, isLoading: data.isLoading }
}
